/**
 * Component list, register here to setting it in the form
 */
import {
  AutoComplete,
  // Cascader,
  Checkbox,
  DatePicker,
  Divider,
  Input,
  InputNumber,
  Radio,
  // Rate,
  Select,
  // Slider,
  Switch,
  Textarea,
  TimePicker,
  // Transfer,
  // TreeSelect,
} from 'ant-design-vue';
import type { Component } from 'vue';
import { createAsyncComponent } from '@mts-fe/utils';
import ReadonlyNumber from '@mts/components/Base/src/ReadonlyNumber.vue';
// import { BasicTitle } from '@mts/components/Basic';
// import { BasicUpload, ImageUpload } from '@mts/components/Upload';
import { MUpload } from '@mts/render/components/Upload';
import ApiButtonGroup from './components/ApiButtonGroup.vue';
// import ApiCascader from './components/ApiCascader.vue';
import ApiRadioGroup from './components/ApiRadioGroup.vue';
import ApiSegmented from './components/ApiSegmented.vue';
import ApiSelect from './components/ApiSelect.vue';
import ApiSelectAdd from './components/ApiSelectAdd.vue';
// import ApiTransfer from './components/ApiTransfer.vue';
// import ApiTree from './components/ApiTree.vue';
import ApiTreeSelect from './components/ApiTreeSelect.vue';
import InputCode from './components/InputCode.vue';
import InputRange from './components/InputRange.vue';
import LongText from './components/LongText.vue';
import ModalTableSelect from './components/ModalTableSelect.vue';
import RadioButtonGroup from './components/RadioButtonGroup.vue';
import ReadonlyText from './components/ReadonlyText.vue';
import Stepper from './components/Stepper.vue';
import VirtualInput from './components/VirtualInput.vue';
import type { ComponentType } from './types';

const componentMap = new Map<ComponentType | string, Component>();

componentMap.set('Input', Input);
componentMap.set('Textarea', Textarea);
// componentMap.set('InputGroup', Input.Group);
componentMap.set('InputPassword', Input.Password);
componentMap.set('InputSearch', Input.Search);
componentMap.set('InputCode', InputCode);
componentMap.set('InputRange', InputRange);
componentMap.set('LongText', LongText);
componentMap.set('ReadonlyText', ReadonlyText);
componentMap.set('ReadonlyNumber', ReadonlyNumber);
componentMap.set('InputTextArea', Input.TextArea);
componentMap.set('InputNumber', InputNumber);
componentMap.set('AutoComplete', AutoComplete);
// componentMap.set('ImageUpload', ImageUpload);
componentMap.set('ApiSegmented', ApiSegmented);
componentMap.set('Select', Select);
componentMap.set('ApiSelect', ApiSelect);
componentMap.set('ApiSelectAdd', ApiSelectAdd);
// componentMap.set('ApiTree', ApiTree);
// componentMap.set('TreeSelect', TreeSelect);
componentMap.set('ApiTreeSelect', ApiTreeSelect);
componentMap.set('ApiRadioGroup', ApiRadioGroup);
componentMap.set('ApiButtonGroup', ApiButtonGroup);
componentMap.set('ModalTableSelect', ModalTableSelect);
componentMap.set(
  'QuickRangePicker',
  createAsyncComponent(() => import('./components/QuickRangePicker.vue')),
);
componentMap.set('Stepper', Stepper);
componentMap.set('VirtualInput', VirtualInput);
componentMap.set('Switch', Switch);
componentMap.set('RadioButtonGroup', RadioButtonGroup);
componentMap.set('RadioGroup', Radio.Group);
componentMap.set('Checkbox', Checkbox);
componentMap.set('CheckboxGroup', Checkbox.Group);
// componentMap.set('ApiCascader', ApiCascader);
// componentMap.set('Cascader', Cascader);
// componentMap.set('Slider', Slider);
// componentMap.set('Rate', Rate);
// componentMap.set('Transfer', Transfer);
// componentMap.set('ApiTransfer', ApiTransfer);

componentMap.set('DatePicker', DatePicker);
componentMap.set('MonthPicker', DatePicker.MonthPicker);
componentMap.set('RangePicker', DatePicker.RangePicker);
// componentMap.set('WeekPicker', DatePicker.WeekPicker);
componentMap.set('TimePicker', TimePicker);
// componentMap.set('TimeRangePicker', TimePicker.TimeRangePicker);
componentMap.set(
  'IconPicker',
  createAsyncComponent(() => import('./components/IconPicker.vue')),
);

componentMap.set('MUpload', MUpload);
// componentMap.set('Upload', BasicUpload);
componentMap.set('Divider', Divider);

// componentMap.set('BasicTitle', BasicTitle);

export { componentMap };
